import { FundAccountParticipantCost, ParticipantCostRequest } from 'model/fund-account';
import { action } from 'typesafe-actions';
import { GiroWebappError } from '../../../model/error';
import { FundAccountParticipantCostActionTypes } from './types';

export const participantCostRequest = (request: ParticipantCostRequest) => action(FundAccountParticipantCostActionTypes.PARTICIPANT_COST_REQUEST, request);
export const participantCostSuccess = (response: FundAccountParticipantCost) => action(FundAccountParticipantCostActionTypes.PARTICIPANT_COST_SUCCESS, response);
export const participantCostError = (error: GiroWebappError) => action(FundAccountParticipantCostActionTypes.PARTICIPANT_COST_ERROR, error);
export const participantCostResetState = () => action(FundAccountParticipantCostActionTypes.PARTICIPANT_COST_RESET_STATE);
